/* eslint-disable */
export const getFullName = (person) => (person ? `${person.firstName} ${person.lastName}` : '');
